var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubscriptionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 8,
    fill: "#192235"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.864 17.2013L19.194 13.3847C19.2945 13.2694 19.4187 13.177 19.5579 13.1137C19.6972 13.0503 19.8485 13.0176 20.0015 13.0176C20.1545 13.0176 20.3057 13.0503 20.445 13.1137C20.5843 13.177 20.7084 13.2694 20.809 13.3847L24.139 17.2013L27.3165 15.1947C27.4909 15.0851 27.6931 15.028 27.8991 15.0303C28.1051 15.0326 28.306 15.0941 28.478 15.2076C28.6499 15.3211 28.7855 15.4817 28.8686 15.6701C28.9516 15.8586 28.9787 16.0671 28.9465 16.2705L27.4365 25.7055C27.3796 26.062 27.1975 26.3865 26.9229 26.6208C26.6482 26.8551 26.2991 26.9838 25.9381 26.9838H14.0648C13.3198 26.9838 12.684 26.4422 12.5665 25.7055L11.0565 16.2705C11.0239 16.067 11.0507 15.8583 11.1336 15.6696C11.2166 15.4809 11.3523 15.3202 11.5243 15.2066C11.6963 15.0931 11.8975 15.0316 12.1036 15.0294C12.3097 15.0273 12.5121 15.0847 12.6865 15.1947L15.864 17.2013ZM12.3531 16.463L13.8006 25.508C13.8105 25.5709 13.8426 25.6283 13.891 25.6697C13.9395 25.7111 14.0011 25.7338 14.0648 25.7338H25.9381C26.0018 25.7338 26.0634 25.7111 26.1119 25.6697C26.1603 25.6283 26.1924 25.5709 26.2023 25.508L27.6498 16.463L24.6773 18.3397C24.4611 18.4762 24.2032 18.531 23.9502 18.4942C23.6972 18.4573 23.4656 18.3313 23.2973 18.1388L20.0015 14.3605L16.7056 18.1388C16.3581 18.5363 15.7723 18.6222 15.3256 18.3397L12.3531 16.463Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M26.6997 22.6074C26.8655 22.6074 27.0244 22.6733 27.1416 22.7905C27.2588 22.9077 27.3247 23.0667 27.3247 23.2324C27.3247 23.3982 27.2588 23.5572 27.1416 23.6744C27.0244 23.7916 26.8655 23.8574 26.6997 23.8574H13.3047C13.1389 23.8574 12.98 23.7916 12.8627 23.6744C12.7455 23.5572 12.6797 23.3982 12.6797 23.2324C12.6797 23.0667 12.7455 22.9077 12.8627 22.7905C12.98 22.6733 13.1389 22.6074 13.3047 22.6074H26.6997Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionIcon);
export default __webpack_public_path__ + "static/media/subscription_icon.b83333f8f5ecfb8cc2ed238e39d87144.svg";
export { ForwardRef as ReactComponent };